import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from './ui/AnimatedSection';
const QUESTIONS = ['¿Qué evalúo primero?', '¿Qué prueba debería elegir?', '¿Qué significa este hallazgo?', '¿Qué debería priorizar?', '¿Cómo progresaría este caso?'];
export function ProblemSection() {
  return <AnimatedSection className="relative bg-white border-t border-navy-900/[0.07] py-9 sm:py-12 md:py-14 overflow-hidden" data-id="element-185" data-mp="2vppjwz3lpq8j">
      {/* Editorial numeral + soft clinical wash */}
      <span aria-hidden className="pointer-events-none select-none absolute -top-4 right-2 sm:right-8 font-heading font-extrabold text-[6rem] sm:text-[9rem] leading-none text-navy-900/[0.045]" data-id="element-186" data-mp="35gu1m6knvp72">
        01
      </span>
      <div aria-hidden className="pointer-events-none absolute -bottom-16 -left-16 w-[260px] h-[260px] rounded-full bg-clinic/[0.07] blur-3xl" data-id="element-187" data-mp="3ehs4umn9zsol" />

      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-188" data-mp="1k3r3nv496tlc">
        <h2 className="font-heading text-navy-950 tracking-tight text-[1.35rem] sm:text-[2.1rem] md:text-[2.3rem] leading-[1.14] mb-4 sm:mb-5" data-id="element-189" data-mp="jdddkbkzaix4">
          <span className="font-extrabold" data-id="element-190" data-mp="oczp8gl5rr3t">Sabes la teoría.</span>{' '}
          <span className="font-medium text-navy-800/70" data-id="element-191" data-mp="sdjnxoldr2s2">
            Pero frente al caso aparecen{' '}
            <span className="font-editorial italic text-gold-deep font-normal" data-id="element-192" data-mp="x4rw6haz4i3n">
              otras preguntas.
            </span>
          </span>
        </h2>

        <ul className="flex flex-wrap gap-1.5 sm:gap-2 mb-5" data-id="element-193" data-mp="125z3kf97ff9s">
          {QUESTIONS.map((q, idx) => <motion.li key={q} initial={{
          opacity: 0,
          y: 8
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          delay: Math.min(idx, 4) * 0.04,
          duration: 0.26,
          ease: [0.23, 1, 0.32, 1]
        }} className="font-editorial italic text-navy-900 text-[12.5px] sm:text-[15px] leading-snug border-l-2 border-l-gold pl-2.5 pr-1 py-0.5" data-id="element-194" data-mp="1c1sr0togot6c" data-mpi={idx}>
              {q}
            </motion.li>)}
        </ul>

        <p className="text-[13px] sm:text-[16px] text-navy-800/75 leading-relaxed mb-2.5" data-id="element-195" data-mp="tz3rhf32q197">
          Conocer información no siempre significa saber cómo organizarla frente
          a un caso real.
        </p>
        <p className="text-[13.5px] sm:text-[17px] text-navy-950 font-semibold leading-snug" data-id="element-196" data-mp="12z0elc9tes25">
          Atlas Clínico organiza esa información para ayudarte a evaluar,
          interpretar y decidir con mayor estructura.
        </p>
      </div>
    </AnimatedSection>;
}